const User = class {
    constructor(object) {
        if (object === undefined) {
            this.username = null;
            this.email = null;
            this.firstName = null;
            this.lastName = null;
            this.role = null;
            // Flag del sistema (Django is_superuser). Solo decide qué se PINTA
            // (menú/rutas de la consola de operaciones); la autorización real la
            // hace el backend en cada request (superadmin.decorators).
            this.isSuperuser = false;
            this.settings = {};
        } else {
            this.username = object.username || null;
            this.email = object.email || null;
            this.firstName = object.firstName || null;
            this.lastName = object.lastName || null;
            this.role = object.role || null;
            this.isSuperuser = object.isSuperuser || false;
            this.settings = object.settings || {};
        }
    }
}

export default User